export default __webpack_public_path__ + "static/swift-8c1ffb31d163940d63ebf78f6603ce84.png";